import {useState, useEffect, useContext} from 'react';
import {ConnectionFactory} from "../../backends/YiiRoutes";
import {StoreContext} from "../../stores/StoreLoader";

export default function useSchoolBlocksApi(initialUrl = '', initialData = null, initialHttpMethod = 'GET') {
    const {organizationStore} = useContext(StoreContext);
    const [apiParameters, setApiParameters] = useState({ url: initialUrl, type: initialHttpMethod, data: initialData});
    const [result, setResult] = useState({status: 0, statusText: null, data: null, error: null});
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading && apiParameters.url !== null && apiParameters.url !== '') {
                setIsError(false);
                setIsLoading(true);

                ConnectionFactory(
                    organizationStore.currentOrganization.id,
                    apiParameters.url,
                    apiParameters,
                ).done((data, textStatus, jqXHR) => {
                    setResult({
                        status: jqXHR.status,
                        statusText: textStatus,
                        data: data,
                        error: null,
                    });
                    setIsLoading(false);
                }).fail((jqXHR, textStatus, errorThrown) => {
                    setResult({
                        status: jqXHR.status,
                        statusText: textStatus,
                        data: null,
                        error: errorThrown,
                    });
                    setIsError(true);
                    setIsLoading(false);
                });
            }
        };
        fetchData();
    }, [apiParameters]);
    return [{ result, isLoading, isError }, setApiParameters];
}
